const clearLocalStorageOnlogout=()=>{
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("accessToken")
  localStorage.removeItem("UTZ")
  localStorage.removeItem("lastActiveTime");
  localStorage.removeItem("appointmentSource");
  //localStorage.removeItem("siteCred");
  }
  export default clearLocalStorageOnlogout